import backToTop from "./components/backToTop";
import nav from "./components/nav";
import smoothScroll from "./components/smoothScroll";

nav();
smoothScroll();
backToTop();

// Dynamically load components based on DOM presence
const components = [
  { selector: ".js-accordion", loader: () => import("./components/accordion") },
  { selector: ".js-add-wrapper", loader: () => import("./components/addWrapper") },
  { selector: ".js-carousel", loader: () => import("./components/carousel") },
  { selector: ".js-container-with-video", loader: () => import("./components/containerWithVideo") },
  { selector: ".js-content-feed", loader: () => import("./components/contentFeed") },
  { selector: ".js-date-time-picker", loader: () => import("./components/dateTimePicker") },
  { selector: ".js-dropdown-button", loader: () => import("./components/dropdownButton") },
  { selector: ".js-filters", loader: () => import("./components/filters") },
  { selector: ".js-gallery", loader: () => import("./components/gallery") },
  { selector: ".js-gallery-carousel", loader: () => import("./components/galleryCarousel") },
  { selector: ".js-grid-carousel", loader: () => import("./components/gridCarousel") },
  { selector: ".js-iframe-form", loader: () => import("./components/iframeFormHandler") },
  { selector: ".js-iframe-modal-trigger", loader: () => import("./components/iframeModalTrigger") },
  { selector: ".js-language-picker-list", loader: () => import("./components/languagePicker") },
  { selector: ".js-map", loader: () => import("./components/map") },
  { selector: ".js-marquee", loader: () => import("./components/marquee") },
  { selector: ".js-masonry", loader: () => import("./components/masonry") },
  { selector: ".js-modal-trigger", loader: () => import("./components/modalTrigger") },
  { selector: ".js-notification", loader: () => import("./components/notification") },
  { selector: ".js-open-slideout", loader: () => import("./components/slideout") },
  { selector: ".js-restaurants-carousel", loader: () => import("./components/restaurantsCarousel") },
  { selector: ".js-room-booking", loader: () => import("./components/roomBooking") },
  { selector: ".js-search", loader: () => import("./components/search") },
  { selector: ".js-secondary-navigation", loader: () => import("./components/secondaryNavigation") },
  { selector: ".js-summary-carousel", loader: () => import("./components/summaryCarousel") },
  { selector: ".js-tabs", loader: () => import("./components/tabs") },
  { selector: ".js-video-with-facade", loader: () => import("./components/video") },
];

components.forEach(({ selector, loader }) => {
  if (document.querySelector(selector)) {
    loader().then((module) => {
      if ("default" in module && typeof module.default === "function") {
        module.default();
      }
    });
  }
});
